export default __webpack_public_path__ + "static/our-chat-7821c8729be8301b204cb77f17666c48.webp";